const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

// Format money, amount is expressed in cents ie. $1 = 100
export const formatMoney = (amount: number): string => {
  return formatter.format(amount / 100);
};

// Unformat Money, takes a string input '$0.00' (like the output of formatMoney()) and returns a number 0.00
export const unFormatMoney = (value: string): number => {
  // regex to remove all non-numeric characters except for the decimal point
  return Number(value.replace(/[^0-9.-]+/g, ''));
};
